import { createElement } from 'react';
const Layout = function Layout({ style: styleOption = {}, children, layout, ...otherProps }) {
    const arr = [];
    for (let i = 0; i < layout; i++) {
        arr.push(i);
    }
    return (createElement("div", { ...otherProps, style: { display: 'flex', padding: '4px', ...styleOption } }, arr.map(item => createElement("div", { style: { flex: 1, marginLeft: item == 0 ? "0px" : "20px" } }, children[item]))));
};
export default Layout;
